// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-TestPage-TimelineDemo-TimelineDemo-module__mainBox--PIyXN {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftBox--B3ct7 {
  transition: width 150ms ease-in-out;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftTopBox--DW3SG {
  transition: width 150ms ease-in-out;
  overflow: hidden;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__rightTopBox--foupZ {
  overflow: hidden;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftBottomBox--SiAKJ {
  transition: width 150ms ease-in-out;
  overflow-y: hidden;
  overflow-x: scroll;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__rightBottomBox--VQ4w6 {
  overflow-x: scroll;
  overflow-y: auto;
  position: relative;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__commonPart--K9dMR {
  overflow-y: visible;
  display: grid;
  grid-auto-rows: 30px;
  overflow-x: hidden;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftPart--AbObP {
  overflow-y: visible;
  display: grid;
  grid-auto-rows: 30px;
  overflow-x: hidden;
  grid-template-columns: 40px 32px 170px 120px 120px;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__rightPart--cwfZh {
  overflow-y: visible;
  display: grid;
  grid-auto-rows: 30px;
  overflow-x: hidden;
  border-left: 2px solid #eee;
  position: relative;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftCollapsed--qMait {
  width: 0;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftCollapseSwitch--SOOjS {
  border: none;
  color: white;
  background-color: #b1b0b5;
  position: absolute;
  left: 0;
  top: 50%;
  width: 16px;
  height: 32px;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0 5px 5px 0;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__limited--cpnBd {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__executors--K7bRs {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__status-closed--nWW2S {
  color: #c0c0c0;
  text-decoration: line-through;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__statusView--BYrC4 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__statusView--BYrC4::before {
  display: block;
  content: " ";
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__status-closed--nWW2S .src-pages-TestPage-TimelineDemo-TimelineDemo-module__statusView--BYrC4::before {
  background: green;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__status-open--LpRFb .src-pages-TestPage-TimelineDemo-TimelineDemo-module__statusView--BYrC4::before {
  background: gray;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__status-inProgress--Iesrr .src-pages-TestPage-TimelineDemo-TimelineDemo-module__statusView--BYrC4::before {
  background: orange;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__status-completed--UHA5q .src-pages-TestPage-TimelineDemo-TimelineDemo-module__statusView--BYrC4::before {
  background: blue;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__expandButton--qE0UD {
  border: none;
  padding: 0;
  background: none;
  cursor: pointer;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__cell--JJ7vT {
  display: flex;
  flex-direction: row;
  padding: 0 8px;
  height: 100%;
  min-height: 30px;
  align-items: center;
  border-top: thin solid #eee;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftHeader--ijMWs {
  grid-row: span 2;
  justify-content: center;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__taskName--MfmoE {
  font-weight: bold;
  grid-column: span 3;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__rightBorder--edzB4 {
  border-right: thin solid #eee;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftBorder--CM2ab {
  border-left: thin solid #eee;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__dateCell--Hu_Ps {
  justify-content: center;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__holiday--TVyUm {
  background-color: #f8f9fe;
  color: #829abc;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__taskBox--Jqwbg {
  position: absolute;
  z-index: 1;
  display: flex;
  flex-direction: column;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__taskBoxText--mcGBK {
  font-size: 14px;
  font-weight: bold;
  padding: 3px 6px;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__taskBrick--kWmus {
  height: 4px;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__subtaskBox--Xheu1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 14px;
  position: absolute;
  z-index: 1;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__subtaskBrick--ZnXcw {
  border: transparent solid thin;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__subtaskInfo--knBUx {
  white-space: nowrap;
  font-size: 14px;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__bond--rx9a5 {
  z-index: 2;
  position: absolute;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__bondLine--kFRYW {
  stroke: brown;
  stroke-width: 1;
  fill: none;
}
.src-pages-TestPage-TimelineDemo-TimelineDemo-module__bondArrow--p5Ur5 {
  fill: brown;
}
`, "",{"version":3,"sources":["webpack://./src/pages/TestPage/TimelineDemo/TimelineDemo.module.less"],"names":[],"mappings":"AAWA;EACE,aAAA;EACA,+BAAA;EACA,4BAAA;AAVF;AAaA;EACE,mCAAA;AAXF;AAaA;EAFE,mCAAA;EAIA,gBAAA;AAXF;AAaA;EACE,gBAAA;AAXF;AAaA;EATE,mCAAA;EAWA,kBAAA;EACA,kBAAA;AAXF;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;AAXF;AAcA;EACE,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;AAZF;AAcA;EALE,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EAIA,kDAAA;AATF;AAWA;EATE,mBAAA;EACA,aAAA;EACA,oBAAA;EACA,kBAAA;EAQA,2BAAA;EACA,kBAAA;AANF;AAQA;EACE,QAAA;AANF;AAQA;EACE,YAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;AANF;AASA;EACE,gBAAA;EACA,mBAAA;EACA,uBAAA;AAPF;AASA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAPF;AAUA;EACE,cAAA;EACA,6BAAA;AARF;AAWA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,QAAA;AATF;AAUE;EACE,cAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AARJ;AASI;EACE,iBAAA;AAPN;AASI;EACE,gBAAA;AAPN;AASI;EACE,kBAAA;AAPN;AASI;EACE,gBAAA;AAPN;AAYA;EACE,YAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;AAVF;AAaA;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EAEA,2BAAA;AAZF;AAeA;EACE,gBAAA;EACA,uBAAA;AAbF;AAeA;EACE,iBAAA;EACA,mBAAA;AAbF;AAgBA;EACE,6BAAA;AAdF;AAgBA;EACE,4BAAA;AAdF;AAgBA;EACE,uBAAA;AAdF;AAgBA;EACE,yBAAA;EACA,cAAA;AAdF;AAiBA;EACE,kBAAA;EACA,UAAA;EAEA,aAAA;EACA,sBAAA;AAhBF;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAhBF;AAkBA;EACE,WAAA;AAhBF;AAmBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EAEA,kBAAA;EACA,UAAA;AAlBF;AAoBA;EACE,8BAAA;AAlBF;AAoBA;EACE,mBAAA;EACA,eAAA;AAlBF;AAoBA;EACE,UAAA;EACA,kBAAA;AAlBF;AAoBA;EACE,aAAA;EACA,eAAA;EACA,UAAA;AAlBF;AAoBA;EACE,WAAA;AAlBF","sourcesContent":["@gridColor: #eee;\n@rowHeight: 30px;\n\n// +-mainBox---------------------------+\n// | +-leftTop----+ +-rightTop ------+ |\n// | +------------+ +----------------+ |\n// | +-leftBottom-+ +-rightBottom----^ |\n// | |            | |                | |\n// | +<---------->+ +<-------------->v |\n// +-----------------------------------+\n\n.mainBox {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  grid-template-rows: auto 1fr;\n  // max-height: 400px;\n}\n.leftBox {\n  transition: width 150ms ease-in-out;\n}\n.leftTopBox {\n  .leftBox();\n  overflow: hidden;\n}\n.rightTopBox {\n  overflow: hidden;\n}\n.leftBottomBox {\n  .leftBox();\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n.rightBottomBox {\n  overflow-x: scroll;\n  overflow-y: auto;\n  position: relative;\n}\n\n.commonPart {\n  overflow-y: visible;\n  display: grid;\n  grid-auto-rows: @rowHeight;\n  overflow-x: hidden;\n}\n.leftPart {\n  .commonPart();\n  grid-template-columns: 40px 32px 170px 120px 120px;\n}\n.rightPart {\n  .commonPart();\n  border-left: 2px solid @gridColor;\n  position: relative;\n}\n.leftCollapsed {\n  width: 0;\n}\n.leftCollapseSwitch {\n  border: none;\n  color: white;\n  background-color: #b1b0b5;\n  position: absolute;\n  left: 0;\n  top: 50%;\n  width: 16px;\n  height: 32px;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border-radius: 0 5px 5px 0;\n}\n\n.limited {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.executors {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n\n.status-closed {\n  color: #c0c0c0;\n  text-decoration: line-through;\n}\n\n.statusView {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 5px;\n  &::before {\n    display: block;\n    content: \" \";\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    .status-closed & {\n      background: green;\n    }\n    .status-open & {\n      background: gray;\n    }\n    .status-inProgress & {\n      background: orange;\n    }\n    .status-completed & {\n      background: blue;\n    }\n  }\n}\n\n.expandButton {\n  border: none;\n  padding: 0;\n  background: none;\n  cursor: pointer;\n}\n\n.cell {\n  display: flex;\n  flex-direction: row;\n  padding: 0 8px;\n  height: 100%;\n  min-height: @rowHeight;\n  align-items: center;\n\n  border-top: thin solid @gridColor;\n}\n\n.leftHeader {\n  grid-row: span 2;\n  justify-content: center;\n}\n.taskName {\n  font-weight: bold;\n  grid-column: span 3;\n}\n\n.rightBorder {\n  border-right: thin solid @gridColor;\n}\n.leftBorder {\n  border-left: thin solid @gridColor;\n}\n.dateCell {\n  justify-content: center;\n}\n.holiday {\n  background-color: #f8f9fe;\n  color: #829abc;\n}\n\n.taskBox {\n  position: absolute;\n  z-index: 1;\n\n  display: flex;\n  flex-direction: column;\n}\n.taskBoxText {\n  font-size: 14px;\n  font-weight: bold;\n  padding: 3px 6px;\n}\n.taskBrick {\n  height: 4px;\n}\n\n.subtaskBox {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 14px;\n\n  position: absolute;\n  z-index: 1;\n}\n.subtaskBrick {\n  border: transparent solid thin;\n}\n.subtaskInfo {\n  white-space: nowrap;\n  font-size: 14px;\n}\n.bond {\n  z-index: 2;\n  position: absolute;\n}\n.bondLine {\n  stroke: brown;\n  stroke-width: 1;\n  fill: none;\n}\n.bondArrow {\n  fill: brown;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainBox": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__mainBox--PIyXN`,
	"leftBox": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftBox--B3ct7`,
	"leftTopBox": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftTopBox--DW3SG`,
	"rightTopBox": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__rightTopBox--foupZ`,
	"leftBottomBox": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftBottomBox--SiAKJ`,
	"rightBottomBox": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__rightBottomBox--VQ4w6`,
	"commonPart": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__commonPart--K9dMR`,
	"leftPart": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftPart--AbObP`,
	"rightPart": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__rightPart--cwfZh`,
	"leftCollapsed": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftCollapsed--qMait`,
	"leftCollapseSwitch": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftCollapseSwitch--SOOjS`,
	"limited": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__limited--cpnBd`,
	"executors": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__executors--K7bRs`,
	"status-closed": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__status-closed--nWW2S`,
	"statusView": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__statusView--BYrC4`,
	"status-open": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__status-open--LpRFb`,
	"status-inProgress": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__status-inProgress--Iesrr`,
	"status-completed": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__status-completed--UHA5q`,
	"expandButton": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__expandButton--qE0UD`,
	"cell": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__cell--JJ7vT`,
	"leftHeader": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftHeader--ijMWs`,
	"taskName": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__taskName--MfmoE`,
	"rightBorder": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__rightBorder--edzB4`,
	"leftBorder": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__leftBorder--CM2ab`,
	"dateCell": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__dateCell--Hu_Ps`,
	"holiday": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__holiday--TVyUm`,
	"taskBox": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__taskBox--Jqwbg`,
	"taskBoxText": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__taskBoxText--mcGBK`,
	"taskBrick": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__taskBrick--kWmus`,
	"subtaskBox": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__subtaskBox--Xheu1`,
	"subtaskBrick": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__subtaskBrick--ZnXcw`,
	"subtaskInfo": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__subtaskInfo--knBUx`,
	"bond": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__bond--rx9a5`,
	"bondLine": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__bondLine--kFRYW`,
	"bondArrow": `src-pages-TestPage-TimelineDemo-TimelineDemo-module__bondArrow--p5Ur5`
};
export default ___CSS_LOADER_EXPORT___;
